module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug"
  }, [_c('div', {
    ref: "performance",
    staticClass: "performance"
  }), (false) ? _c('ul') : _vm._e(), _c('ul', [_c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("STAGE")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.stageLabel))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("PROGRESS")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.floor(_vm.progress * 100)) + "%")])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("VELOCITY")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.velocity)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("BASE VELOCITY")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.baseVelocity)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("NUM INFRONT")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.numInfront))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("PACE")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(Math.round(3000000 / _vm.velocity / 1000 / 60 * 100) / 100 * 60)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("DURATION")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.duration / 1000)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("BLOOM")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.bloom))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("ZOOM")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.zoom))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68d92b28"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/debug/Debug.vue
// module id = 605
// module chunks = 1